import script from "./subsidiary-name-cell.vue?vue&type=script&setup=true&lang=ts"
export * from "./subsidiary-name-cell.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__